module.exports = __webpack_public_path__ + "img/sf.0ab5ac50.jpg";